import { Button } from "@/components/Base/Button";
import { Tooltip } from "@/components/Common/Tooltip";
import {
  CircleAlertIcon,
  CircleCheckBigIcon,
  ClockIcon,
  RefreshCwIcon,
} from "lucide-react";
import { useStore } from "@/stores/useStore";
import { useEffect, useState } from "react";

export const SyncStatus = () => {
  const { lastSyncedTime, syncDriver, syncWithSource } = useStore();
  const [hovering, setHovering] = useState(false);
  const [queued, setQueued] = useState(false);

  useEffect(() => {
    if (syncDriver?.status) setQueued(false);
  }, [syncDriver?.status]);

  const handleClick = () => {
    setQueued(true);
    syncWithSource(true);
  };

  const icon = () => {
    if (queued || syncDriver?.status === "inprogress") {
      return <ClockIcon size={20} />;
    }
    if (hovering) {
      return <RefreshCwIcon size={20} />;
    }
    if (syncDriver?.status === "complete") {
      return <CircleCheckBigIcon size={20} className="text-green" />;
    }
    if (syncDriver?.status === "error") {
      return <CircleAlertIcon size={20} className="text-orange-500" />;
    }
  };

  return (
    <div className="flex flex-row items-center justify-between">
      <Button
        variant={"ghost"}
        disabled={queued || syncDriver?.status === "inprogress"}
        onClick={handleClick}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      >
        {syncDriver?.status === "error" && !queued && (
          <Tooltip message={"Last sync failed! Click to try again."}>
            {icon()}
          </Tooltip>
        )}
        {queued && (
          <Tooltip message="Sync queued! It will process shortly.">
            {icon()}
          </Tooltip>
        )}
        {syncDriver?.status === "inprogress" && !queued && (
          <Tooltip message="Sync in progress">{icon()}</Tooltip>
        )}
        {syncDriver?.status === "complete" && !queued && (
          <Tooltip
            message={`Last sync complete at ${new Date(lastSyncedTime).toLocaleTimeString()}. Click to start a new sync.`}
          >
            {icon()}
          </Tooltip>
        )}
      </Button>
    </div>
  );
};
